import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-pushpinsimple",
  "use": "icon-th-pushpinsimple-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-pushpinsimple\">\n<path d=\"M27 21H25.8388L23.1925 6H24C24.2652 6 24.5196 5.89464 24.7071 5.70711C24.8946 5.51957 25 5.26522 25 5C25 4.73478 24.8946 4.48043 24.7071 4.29289C24.5196 4.10536 24.2652 4 24 4H8C7.73478 4 7.48043 4.10536 7.29289 4.29289C7.10536 4.48043 7 4.73478 7 5C7 5.26522 7.10536 5.51957 7.29289 5.70711C7.48043 5.89464 7.73478 6 8 6H8.8075L6.16125 21H5C4.73478 21 4.48043 21.1054 4.29289 21.2929C4.10536 21.4804 4 21.7348 4 22C4 22.2652 4.10536 22.5196 4.29289 22.7071C4.48043 22.8946 4.73478 23 5 23H15V30C15 30.2652 15.1054 30.5196 15.2929 30.7071C15.4804 30.8946 15.7348 31 16 31C16.2652 31 16.5196 30.8946 16.7071 30.7071C16.8946 30.5196 17 30.2652 17 30V23H27C27.2652 23 27.5196 22.8946 27.7071 22.7071C27.8946 22.5196 28 22.2652 28 22C28 21.7348 27.8946 21.4804 27.7071 21.2929C27.5196 21.1054 27.2652 21 27 21ZM10.8387 6H21.1612L23.8075 21H8.1925L10.8387 6Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-pushpinsimple.svg
// module id = iuAQ
// module chunks = 84